import { useAuth } from "@/lib/auth/context";
import {
  ChildDashboard,
  ParentDashboard,
} from "@/components/screens/Dashboards";

export default function DashboardPage() {
  const { userDoc } = useAuth();
  if (!userDoc) return null;
  return userDoc.role === "parent" ? <ParentDashboard /> : <ChildDashboard />;
}
